import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { TopBar, Notice, Spinner } from '../components/ui';

/** Moyasar redirects here with ?id=<payment id>; we verify server-side with the shop's secret key. */
export default function Paid() {
  const [sp] = useSearchParams();
  const { slug } = useParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState('');
  useEffect(() => {
    const id = sp.get('id'); const sub = sp.get('sub');
    if (!id || !sub) { setMsg('رابط غير مكتمل.'); return; }
    api.post<{ ok: boolean; card_token?: string; message_ar?: string }>('/api/public/payments/callback', { subscription_id: sub, payment_id: id })
      .then((r) => { if (r.ok && r.card_token) nav(`/card/${r.card_token}?new=1`, { replace: true }); else setMsg(r.message_ar ?? 'لم تكتمل عملية الدفع.'); })
      .catch(() => setMsg('تعذر التحقق من الدفعة. إن خُصم المبلغ فستصلك بطاقتك على واتساب خلال دقائق.'));
  }, [sp, nav]);
  return (
    <main className="container py-10 max-w-xl">
      <TopBar />
      {msg ? <><Notice kind="warn">{msg}</Notice><Link className="btn btn-ghost mt-4" to={`/s/${slug}`}>العودة إلى الباقات</Link></> : <Spinner label="نتحقق من الدفعة" />}
    </main>
  );
}
